import React from "react";
import $ from 'jquery';
// import Swipe from 'react-swipe-component'; // it is no needed, but the main swiping idea is from this lib

import SqftIframe from "./sqftIframe";
import ProjectScope from "./projectScope";
import ProjectScopeItem from "./projectScopeItem";
import StepMainView from "./stepMainView";
import ProjectScopeMaterialContent from "./materialContent";
import ProjectScopeFeatureContent from "./featureContent";
import FeatureSelectionBoxView from "./featureSelectionView";
import * as Misc from "./../../misc";
import ActionTypes from "./../../actionTypes";
import StonesStore from "./../../stores/stonesStore";
import Analytics from './../../analytics';

export default class ProjectScopeSteps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      features: StonesStore.dbFeatures(ProjectScope.quote()),
      featureSelectionShown: false,
      featureGroupNameForSelection: null, //feature that will be shown in lightbox
      isSwitching: true,
      entered: [],
      delta: 0, //  how much we need to swipe the page to change step
      x: 0,
      y: 0,
      statusSwipe: false,
      detectedSwipe: false,
    };
  }

  componentDidMount () {
    $(document).on(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
    this.setState({
      isSwitching: false,
      delta: $(window).width() / 3
    }, () => {
      (document.kvConfig.stepFinished !== 0 ) && this.setStep(document.kvConfig.stepFinished);
    });
    // $('.project-scope-main').dragend();
    // setTimeout(() => { window.dispatchEvent(new Event('resize')) }, 0);
    $(window).on('resize', this.handleOrientationChange);
  }

  componentWillReceiveProps (nextProps) {
    // nextProps.finishedStep && this.setState({
    //   step: nextProps.finishedStep // set last step
    // });
  }

  componentWillUnmount () {
    $(document).off(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
    $(window).off('resize', this.handleOrientationChange);
  };

  handleOrientationChange = (e) => {
    this.setState({
      delta: $(window).width() / 3
    })
  };

  handleQuoteDataChanged= () =>{
    this.setState({
      features: StonesStore.dbFeatures(ProjectScope.quote())
    });
  };

  showFeatureSelection=(featureGroupName) =>{
    let entered = this.state.entered;
    let index = _.findIndex(entered, e => e.name === featureGroupName);
    if(index < 0) {
      entered.push({name: featureGroupName, count: 1});
    } else {
      entered[index].count++;
    }
    this.setState({
      featureSelectionShown: true,
      featureGroupNameForSelection: featureGroupName,
      entered
    });
  };

  hasEntered = (featureGroupName) => {
    let entered = this.state.entered;
    let index = _.findIndex(entered, e => e.name === featureGroupName);
    let ret = entered[index].count > 1;
    return ret;
  };

  closeFeatureSelection=(cancel) =>{
    const lightbox = $('.lightbox-wrapper');
    if ( lightbox.length ) {
      lightbox.slideUp(600, ()=> {
        this.setState({
          featureSelectionShown: false
        });
      });
    } else {
      this.setState({
        featureSelectionShown: false
      });
    }
  };

  changeStep = (newStep) => {
    Analytics.sendClickEvent('change-step-' + (newStep > 0 ? 'next' : 'back'));
    const oldStep = this.state.step,
          existNewStep = $(".project-scope-main-body[data-step=" + (this.state.step + newStep) + "]").length;

    var nextStep = oldStep + newStep;
    var oldStepName = (oldStep - 1 >= 0 ? this.state.features[oldStep - 1] : "material").toLowerCase().replace(/\s/g, '-');
    var nextStepName = (nextStep - 1 >= 0 ? this.state.features[nextStep - 1] : "material").toLowerCase().replace(/\s/g, '-');

    Analytics.sendClickEvent('change-step-from-' + oldStepName + '-to-' + nextStepName);

    !this.state.isSwitching && existNewStep && this.setState({
        step: this.state.step + newStep,
        isSwitching: true
      }, () => {
        this.animateChangingSteps(oldStep);
        document.kvConfig.stepFinished = this.state.step;
      });

  };

  setStep = (step) => {

    const oldStep = this.state.step,
      existNewStep = $(".project-scope-main-body[data-step=" + step + "]").length;

    !this.state.isSwitching && existNewStep && (step !== this.state.step) && this.setState({
      step,
      isSwitching: true
    }, () => {
      this.animateChangingSteps(oldStep);
      document.kvConfig.stepFinished = this.state.step;
    });
  };

  animateChangingSteps = (oldStep) => {

    // animating main step view
    if ($(window).width() > 768) {  //fading on desktops

      const
        oldView = $(".project-scope-main-body[data-step=" + oldStep + "]"),
        newView = $(".project-scope-main-body[data-step=" + this.state.step + "]");

      oldView.addClass('project-scope-main-body--spreading'); // for scaling
      newView.addClass('project-scope-main-body--spreading'); // for scaling

      setTimeout(() => {
        oldView.addClass('project-scope-main-body--smallspreading'); // for scaling
        newView.addClass('project-scope-main-body--smallspreading'); // for scaling
      }, 150);

      oldView.find('.project-scope-fading, .project-scope-main-footer').fadeOut(300, () => {
        newView.show();
        newView.find('.project-scope-fading, .project-scope-main-footer').fadeIn(300);
        setTimeout(() => {
          oldView.hide();
          oldView.removeClass('project-scope-main-body--spreading project-scope-main-body--smallspreading'); // for scaling
          newView.removeClass('project-scope-main-body--spreading project-scope-main-body--smallspreading'); // for scaling
          this.setState({
            isSwitching: false
          });
        }, 300)
      });

    } else {  //sliding on mobile

      const
        oldView         = $(".project-scope-main-body[data-step=" + oldStep + "]"),
        newView         = $(".project-scope-main-body[data-step="+this.state.step+"]"),
        stepDescription = newView.find('.project-scope-main-header-description'),
        oversizedClass  = "project-scope-main-header-description--oversized";

      if (oldStep < this.state.step) {
        oldView.addClass('project-scope-main-body--spreading project-scope-main-body--slideleft'); // for scaling
        newView.addClass('project-scope-main-body--spreading project-scope-main-body--slideright'); // for scaling
      } else {
        oldView.addClass('project-scope-main-body--spreading project-scope-main-body--slideright'); // for scaling
        newView.addClass('project-scope-main-body--spreading project-scope-main-body--slideleft'); // for scaling
      }

      setTimeout(()=>{
        oldView.addClass('project-scope-main-body--smallspreading'); // for scaling
        newView.addClass('project-scope-main-body--smallspreading'); // for scaling
      }, 150);

      setTimeout(()=>{

        oldView.hide().find('.project-scope-fading').hide();
        newView.show().find('.project-scope-fading').fadeIn(300);

        if (stepDescription.height() > 60) {
          let allTextArray = stepDescription.text().split(" ");
          while (stepDescription.height() > 60) {
            allTextArray.pop();
            stepDescription.html(allTextArray.join(" "));
          }
          allTextArray.pop(); // remove last word (to place dots)
          stepDescription.html(allTextArray.join(" ") + "...");
          stepDescription.addClass(oversizedClass);
        } else {
          stepDescription.removeClass(oversizedClass);
        }

        oldView.removeClass('project-scope-main-body--spreading project-scope-main-body--smallspreading project-scope-main-body--slideleft project-scope-main-body--slideright');
        newView.removeClass('project-scope-main-body--spreading project-scope-main-body--smallspreading project-scope-main-body--slideright project-scope-main-body--slideleft');

        this.setState({
          isSwitching: false
        });

      }, 600);

    }

  };

  showSquareFootCalc = (feature) => {
    Misc.hideQQGirl();
    this.props.showSqFtCalc();
    SqftIframe.showSquareFootCalc(feature);
  };

  moveStart = (e) => {

    if ($(window).width() < 768 && !document.inputFocused) {

      // e.preventDefault();
      if (this.state.isSwitching) {
        return
      }

      this.setState({
        x: parseFloat(e.clientX ? e.clientX : (e.touches[0] ? e.touches[0].clientX : e.changedTouches[0].clientX)).toFixed(2),
        y: parseFloat(e.clientY ? e.clientY : (e.touches[0] ? e.touches[0].clientY : e.changedTouches[0].clientY)).toFixed(2),
        statusSwipe: true,
        detectedSwipe: false
      });

    }
  };

  move = (e) => {

    if ($(window).width() < 768 && !document.inputFocused) {
      if (this.state.isSwitching) {
        return
      }

      if (this.state.statusSwipe) {

        const
          target = e.target,
          parent = $(target).closest('.project-scope-main-body'),
          fading = parent.find('.project-scope-fading');

        parent.addClass('grabbable');

        let x = parseFloat(e.clientX ? e.clientX : (e.touches[0] ? e.touches[0].clientX : e.changedTouches[0].clientX)).toFixed(2),
          y = parseFloat(e.clientY ? e.clientY : (e.touches[0] ? e.touches[0].clientY : e.changedTouches[0].clientY)).toFixed(2),
          tX = parseFloat((x - this.state.x).toFixed(2)),
          tY = parseFloat((y - this.state.y).toFixed(2));

        if (!this.state.detectedSwipe) {
          if (Math.abs(parseFloat(tX)) >= this.state.delta) {
            if (parseFloat(tX) > this.state.delta && this.state.step === 0) {
              // console.log('onSwipedRight');
              fading.css({
                transform: ''
              });
              return false
            // } else if (parseFloat(tX) < -this.state.delta && this.state.step === this.state.features.length) {
            //   // console.log('onSwipedLeft');
            //   fading.css({
            //     transform: ''
            //   });
            //   return false
            }
          }
        }

        if (Math.abs(tX) > Math.abs(tY)) {
          fading.css({
            transform: `translateX(${tX}px)`
          })
        }

      }
    }
    
  };
  
  moveEnd = (e) => {

    if ($(window).width() < 768) {
      if (this.state.isSwitching) {
        return
      }

      // e.preventDefault();

      const
        target = e.target,
        parent = $(target).closest('.project-scope-main-body'),
        fading = parent.find('.project-scope-fading');

      parent.removeClass('grabbable');

      this.setState({
        x: 0,
        y: 0,
        statusSwipe: false,
        detectedSwipe: false,
      });

      let 
        x = parseFloat(e.clientX ? e.clientX : (e.touches[0] ? e.touches[0].clientX : e.changedTouches[0].clientX)).toFixed(2),
        tX = parseFloat((x - this.state.x).toFixed(2));

      if (!this.state.detectedSwipe) {
        if (Math.abs(parseFloat(tX)) >= this.state.delta) {
          if (parseFloat(tX) > this.state.delta) {
            // console.log('onSwipedRight');
            this.setStep(+parent.attr('data-step') - 1);
          } else if (parseFloat(tX) < -this.state.delta) {
            // console.log('onSwipedLeft');
            if (this.state.step === this.state.features.length) {
              this.props.goToNextView(e);
            } else {
              this.setStep(+parent.attr('data-step') + 1);
            }
          }
          setTimeout(() => {
            fading.css({
              transform: ''
            });
          }, 1000);
          this.setState({ detectedSwipe: true });
          return false;
        } else {
          fading.css({
            transform: ''
          });
          return false;
        }
      } 
    }

  };

  render() {

    const featuresLength = this.state.features.length;

    return (
      <div className={"project-scope-step project-scope-step--"+this.state.step
      + (featuresLength ? " project-scope-step--left-"+((featuresLength+1)-this.state.step) : "")
      + ((this.props.step === featuresLength) ? " project-scope-step--finished" : "")}>
        <div className="project-scope-line project-scope-line--enabled">
          <div className="project-scope-line-inner">
            <ProjectScopeItem disabled={false} groupName="Measurements" datastep={0} setStep={this.setStep} content={
              <ProjectScopeMaterialContent mainview={false}/>
            }/>
            {this.state.features.map((f, index) => {
              return (
                <ProjectScopeItem disabled={false} groupName={f} key={f}
                                  datastep={index+1} setStep={this.setStep}
                                  groupImg={StonesStore.getFeatureGroupIconURL(f, true)}
                                  content={<ProjectScopeFeatureContent groupName={f}
                                              showbutton={this.state.step === (featuresLength + 1)}
                                              showFeatureSelection={this.showFeatureSelection}/>}/>
              );
            })}
          </div>
        </div>
        <section className="project-scope-main" onTouchStart={this.moveStart} onTouchMove={this.move} onTouchEnd={this.moveEnd}
              onMouseDown={this.moveStart} onMouseMove={this.move} onMouseUp={this.moveEnd}>
          <ProjectScopeMaterialContent step={this.state.step} changeStep={this.changeStep}
                                       openKitchenVisualizerIframe={this.props.openKitchenVisualizerIframe}
                                       groupName="Measurements" mainview={true} showSquareFootCalc={this.showSquareFootCalc}/>
          {this.state.features.map((f, index) => {
            return (
              <StepMainView step={this.state.step} datastep={index+1} changeStep={this.changeStep}
                            lastStep={(index+1)  === featuresLength} goToNextView={this.props.goToNextView}
                            openKitchenVisualizerIframe={this.props.openKitchenVisualizerIframe}
                            groupName={f} showFeatureSelection={this.showFeatureSelection} key={f}/>
            );
          })}
        </section>
        <div className="project-scope-line project-scope-line--disabled">
          <div className="project-scope-line-inner">

            {this.state.features.map((f, index) => {
              return (
                <ProjectScopeItem disabled={true} groupName={f} key={f} groupMeta={StonesStore.newquotedata}
                                  datastep={index+1} setStep={this.setStep}
                                  groupImg={StonesStore.getFeatureGroupIconURL(f, false)}/>
              );
            })}
          </div>
        </div>
        <ul className={"project-scope-breadcrumbs" + (featuresLength > 8 ? " project-scope-breadcrumbs--small" : "")}>
          {featuresLength ? <li onClick={()=>this.setStep(this.state.step - 1)}
                                className="project-scope-breadcrumbs-item project-scope-breadcrumbs-item--first"/> : null}
          {featuresLength ? <li onClick={()=>this.setStep(0)} className={"project-scope-breadcrumbs-item "
          + ((this.state.step === 0) ?"project-scope-breadcrumbs-item--active" : "")}/> : null}
          {
            this.state.features.map((feature, index)=> {
              const step = index + 1;
              return (
                <li onClick={()=>this.setStep(step)}
                    className={"project-scope-breadcrumbs-item "+ ((this.state.step === step)
                  ? "project-scope-breadcrumbs-item--active" : "")} key={index + 1}/>
              )
            })
          }
          {featuresLength ? <li onClick={()=>this.setStep(this.state.step + 1)}
                                className="project-scope-breadcrumbs-item project-scope-breadcrumbs-item--last"/> : null}
        </ul>
        {this.state.featureSelectionShown
          ? <FeatureSelectionBoxView groupName={this.state.featureGroupNameForSelection}
                                     changeSkipToNext={this.changeSkipToNext}
                                     close={this.closeFeatureSelection}
                                     showSquareFootCalc={this.showSquareFootCalc}
                                     firstEntry={!this.hasEntered(this.state.featureGroupNameForSelection)}/>
          : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/projectScope/projectScopeSteps.js